// We're using CSS for the banner instead of an image file
// No need to export anything from this file

export default {};
